import * as React from 'react';

export interface UseBhanzuBuddyHandlersProps {
  leadId?: string;
  message: string;
  setMessage: (message: string) => void;
  quickChallengeContextRef: React.RefObject<{
    questionByBB: string;
  } | null>;
  onSendQuickChallengeAnswer?: (answer: string, question: string) => void;
  apiSendMessage?: (message: string) => void;
  prevMessageRef: React.RefObject<string>;
}

export const useBhanzuBuddyHandlers = ({
  leadId,
  message,
  setMessage,
  quickChallengeContextRef,
  onSendQuickChallengeAnswer,
  apiSendMessage,
  prevMessageRef,
}: UseBhanzuBuddyHandlersProps) => {
  const handleSendMessage = React.useCallback(() => {
    if (message.trim()) {
      if (leadId && apiSendMessage) {
        const pendingQC = quickChallengeContextRef.current;
        if (pendingQC && onSendQuickChallengeAnswer) {
          onSendQuickChallengeAnswer(message.trim(), pendingQC.questionByBB);
          quickChallengeContextRef.current = null;
        } else {
          apiSendMessage(message.trim());
        }
      }
      setMessage('');
    }
  }, [
    message,
    leadId,
    apiSendMessage,
    onSendQuickChallengeAnswer,
    quickChallengeContextRef,
    setMessage,
  ]);

  const handleKeyPress = React.useCallback(
    (e: React.KeyboardEvent<HTMLInputElement>) => {
      if (e.key === 'Enter' && !e.shiftKey) {
        e.preventDefault();
        handleSendMessage();
      }
    },
    [handleSendMessage]
  );

  const handleChatInputSend = React.useCallback(
    (chatMessage: string) => {
      if (leadId && apiSendMessage) {
        const pendingQC = quickChallengeContextRef.current;
        if (pendingQC && onSendQuickChallengeAnswer) {
          onSendQuickChallengeAnswer(chatMessage, pendingQC.questionByBB);
          quickChallengeContextRef.current = null;
        } else {
          apiSendMessage(chatMessage);
        }
      }
      setMessage('');
      prevMessageRef.current = '';
    },
    [
      leadId,
      apiSendMessage,
      onSendQuickChallengeAnswer,
      quickChallengeContextRef,
      setMessage,
      prevMessageRef,
    ]
  );

  return {
    handleSendMessage,
    handleKeyPress,
    handleChatInputSend,
  };
};
